export default "__VITE_ASSET__Sf3EvcQ___"